import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'

Vue.use(ElementUI)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = function (err, vm, info) {
        // 仅在控制台打印错误，不显示全局提示框
        console.error('Vue 错误:', err, info);
    };
}

// 1. 定义一个防抖函数
Vue.prototype.$debounce = function(func, delay) {
    let timeoutId;
    // 返回的函数会在组件中被调用，此时 this 指向组件实例
    return function(...args) {
        const context = this; // 这里的 this 是组件实例
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            // 用组件实例作为上下文调用 func
            func.apply(context, args);
        }, delay);
    };
};

Vue.config.errorHandler = function (err, vm, info) {
    // 自定义错误处理（仅在控制台打印，不显示到页面）
    console.error('Vue 组件错误:', err, '信息:', info);
    // 不抛出错误，避免触发全局提示
};

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')